/* ============================================================
   Media.co.uk — Cmd+K search modal
   Hooks into the snippet rendered by theme.liquid.
   Triggers: [data-mc-search-open] click, or ⌘K / Ctrl+K.
   Data: predictive search API (/search/suggest.json) +
         seed markets/mediums in #mc-search-modal-data.
   ============================================================ */
(function () {
  'use strict';

  var modal = document.getElementById('mc-search-modal');
  if (!modal) return;

  var $palette = modal.querySelector('.mc-sm-palette');
  var $input = modal.querySelector('#mc-sm-q');
  var $body = modal.querySelector('#mc-sm-body');
  var $tabs = modal.querySelectorAll('.mc-sm-tab');
  var $loading = modal.querySelector('.mc-sm-loading');
  var seedNode = document.getElementById('mc-search-modal-data');
  var SEED = { markets: [], mediums: [], trending: [], search_url: '/search', brief_url: '/pages/contact' };
  try { if (seedNode) SEED = JSON.parse(seedNode.textContent); } catch (e) {}

  var RECENT_KEY = 'mc-search-recent';
  function loadRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]').slice(0, 5); } catch (e) { return []; }
  }
  function pushRecent(q) {
    if (!q) return;
    var arr = loadRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    arr.unshift(q);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, 5))); } catch (e) {}
  }
  function removeRecent(q) {
    var arr = loadRecent().filter(function (x) { return x !== q; });
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr)); } catch (e) {}
  }

  var ICONS = {
    audio: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 18 0"/><rect x="3" y="13" width="5" height="7" rx="1"/><rect x="16" y="13" width="5" height="7" rx="1"/></svg>',
    video: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="14" height="12" rx="2"/><path d="M17 10l4-2v8l-4-2"/></svg>',
    press: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="15" height="16" rx="1.5"/><path d="M18 8h3v10a2 2 0 0 1-2 2H6"/><line x1="6" y1="8" x2="15" y2="8"/><line x1="6" y1="12" x2="15" y2="12"/><line x1="6" y1="16" x2="11" y2="16"/></svg>',
    ooh: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="12" rx="1"/><line x1="8" y1="20" x2="8" y2="16"/><line x1="16" y1="20" x2="16" y2="16"/></svg>',
    article: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h12l4 4v12H4z"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="16" x2="14" y2="16"/></svg>',
    page: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="3" width="16" height="18" rx="1"/><line x1="8" y1="9" x2="16" y2="9"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="12" y2="17"/></svg>'
  };

  var TYPE_LABEL = {
    market: 'Market', station: 'Station', channel: 'Channel',
    press: 'Press', ooh: 'OOH', article: 'Article', page: 'Page'
  };

  // ----- Classify a Shopify product into our scope -----
  // Predictive search returns `type` = productType ("Audio", "Video", "Press", "OOH").
  // Falls back to tag-sniffing if `type` is blank.
  function classifyProduct(p) {
    var t = (p.type || '').toLowerCase();
    if (t === 'audio') return 'station';
    if (t === 'video') return 'channel';
    if (t === 'press') return 'press';
    if (t === 'ooh') return 'ooh';
    var tags = (p.tags || []).join(' ').toLowerCase();
    var blob = tags + ' ' + (p.title || '').toLowerCase();
    if (/\b(radio|fm)\b/.test(blob)) return 'station';
    if (/\b(tv|television|vod|cinema|streaming|video|broadcast|channel)\b/.test(blob)) return 'channel';
    if (/\b(newspaper|magazine|publisher|daily|weekly|monthly)\b/.test(blob)) return 'press';
    if (/\b(billboard|hoarding|metro|transit|spectacular|dooh|out[- ]of[- ]home|ooh)\b/.test(blob)) return 'ooh';
    return 'station';
  }

  // ----- State -----
  var state = {
    q: '',
    scope: 'all',
    focus: 0,
    visible: [],
    cache: {},
    reqSeq: 0
  };

  // ----- Helpers -----
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
    });
  }
  function highlight(text, q) {
    if (!q) return esc(text);
    var t = String(text || '');
    var idx = t.toLowerCase().indexOf(q.toLowerCase());
    if (idx < 0) return esc(t);
    return esc(t.slice(0, idx)) + '<mark>' + esc(t.slice(idx, idx + q.length)) + '</mark>' + esc(t.slice(idx + q.length));
  }
  function debounce(fn, ms) {
    var t; return function () { var args = arguments, ctx = this; clearTimeout(t); t = setTimeout(function () { fn.apply(ctx, args); }, ms); };
  }

  // ----- Open / close -----
  function openModal() {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mc-sm-open');
    document.body.classList.add('mc-sm-open');
    setTimeout(function () { try { $input.focus(); } catch (e) {} }, 0);
    if ($input.value === '') {
      state.q = ''; state.scope = 'all';
      syncTabs(); renderEmpty();
    }
  }
  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    document.documentElement.classList.remove('mc-sm-open');
    document.body.classList.remove('mc-sm-open');
  }

  // ----- Predictive search fetch -----
  function fetchResults(q) {
    if (state.cache[q]) return Promise.resolve(state.cache[q]);
    var seq = ++state.reqSeq;
    $loading.hidden = false;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product,article,page'
      + '&resources[limit]=10'
      + '&resources[limit_scope]=each'
      + '&resources[options][unavailable_products]=last';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (seq !== state.reqSeq) return null;
        var items = [];
        var rs = (j && j.resources && j.resources.results) || {};
        (rs.products || []).forEach(function (p) {
          var scope = classifyProduct(p);
          // Pull city/country from `City: …` / `Country: …` tags if present.
          var city = '', country = '';
          (p.tags || []).forEach(function (t) {
            if (t.indexOf('City:') === 0) city = t.slice(5).trim();
            else if (t.indexOf('Country:') === 0) country = t.slice(8).trim();
          });
          var metaBits = [];
          if (p.type) metaBits.push(p.type);
          if (city) metaBits.push(city);
          else if (country) metaBits.push(country);
          items.push({
            type: scope, scope: scope,
            title: p.title,
            meta: metaBits.join(' · '),
            detail: '',
            image: p.image,
            url: p.url
          });
        });
        (rs.articles || []).forEach(function (a) {
          items.push({
            type: 'article', scope: 'article',
            title: a.title,
            meta: 'The Brief',
            detail: '',
            image: a.image,
            url: a.url
          });
        });
        (rs.pages || []).forEach(function (pg) {
          items.push({
            type: 'page', scope: 'page',
            title: pg.title,
            meta: 'Page',
            detail: '',
            url: pg.url
          });
        });
        // Add matching markets (client-side substring)
        var ql = q.toLowerCase();
        SEED.markets.forEach(function (m) {
          if ((m.title || '').toLowerCase().indexOf(ql) >= 0 || (m.meta || '').toLowerCase().indexOf(ql) >= 0) {
            items.push(m);
          }
        });
        state.cache[q] = items;
        return items;
      })
      .catch(function () { return []; })
      .finally(function () {
        if (seq === state.reqSeq) $loading.hidden = true;
      });
  }

  // ----- Render: empty state -----
  function renderEmpty() {
    var recents = loadRecent();
    var recentsHtml = recents.length
      ? '<div class="mc-sm-section-h">Recent searches</div>'
        + '<div class="mc-sm-chips">'
        + recents.map(function (r) {
            return '<span class="mc-sm-chip" data-recent="' + esc(r) + '" tabindex="0" role="button">'
              + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="color:var(--sm-ink-56)"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>'
              + esc(r)
              + '<button type="button" class="x" data-recent-x="' + esc(r) + '" title="Remove" aria-label="Remove">×</button>'
              + '</span>';
          }).join('')
        + '</div>'
      : '';

    var trendingHtml = '<div class="mc-sm-section-h">Trending this week</div>'
      + '<div class="mc-sm-chips">'
      + SEED.trending.map(function (t, i) {
          return '<span class="mc-sm-chip" data-recent="' + esc(t) + '" tabindex="0" role="button">'
            + '<span class="rank">' + String(i + 1).padStart(2, '0') + '</span>'
            + esc(t)
            + '</span>';
        }).join('')
      + '</div>';

    var marketsHtml = '<div class="mc-sm-section-h">Browse by market</div>'
      + '<div class="mc-sm-chips">'
      + SEED.markets.slice(0, 12).map(function (m) {
          return '<a class="mc-sm-chip" href="' + esc(m.url) + '">'
            + '<span style="font-size:14px;line-height:1">' + esc(m.flag) + '</span>'
            + esc(m.title)
            + '</a>';
        }).join('')
      + '</div>';

    var mediumsHtml = '<div class="mc-sm-section-h">Browse by medium</div>'
      + '<div class="mc-sm-mediums">'
      + SEED.mediums.map(function (m) {
          return '<a class="mc-sm-medium" href="' + esc(m.url) + '">'
            + '<span class="num">' + esc(m.num) + '</span>'
            + '<span>'
            +   '<span class="label">' + esc(m.label) + '</span>'
            +   '<span class="sub">' + esc(m.sub) + '</span>'
            + '</span>'
            + '</a>';
        }).join('')
      + '</div>';

    $body.innerHTML = recentsHtml + trendingHtml + '<div class="mc-sm-divider"></div>' + marketsHtml + mediumsHtml;
    state.visible = [];
    syncCounts({ all: '—', station: '—', channel: '—', press: '—', ooh: '—', market: '—', article: '—' });

    // Bind chip clicks → seed query
    $body.querySelectorAll('[data-recent]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-recent-x]')) {
          e.stopPropagation();
          var q = e.target.getAttribute('data-recent-x');
          removeRecent(q);
          renderEmpty();
          return;
        }
        var v = el.getAttribute('data-recent');
        $input.value = v; state.q = v; state.scope = 'all';
        syncTabs(); runQuery();
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
      });
    });
  }

  // ----- Render: result groups -----
  function renderResults(items) {
    if (!items || items.length === 0) {
      $body.innerHTML = ''
        + '<div class="mc-sm-no">'
        +   '<h3>No matches for <em>"' + esc(state.q) + '"</em></h3>'
        +   '<p>Stations, channels, publications and articles are indexed daily. If it isn\'t here yet, our planners will source it.</p>'
        +   '<div class="mc-sm-no-acts">'
        +     '<a class="mc-sm-no-btn is-pri" href="' + esc(SEED.brief_url) + '">Send a brief →</a>'
        +     '<button type="button" class="mc-sm-no-btn is-sec" data-mc-clearq>Clear search</button>'
        +   '</div>'
        + '</div>';
      $body.querySelector('[data-mc-clearq]').addEventListener('click', function () {
        $input.value = ''; state.q = ''; state.scope = 'all'; syncTabs(); renderEmpty(); $input.focus();
      });
      syncCounts({ all: 0, station: 0, channel: 0, press: 0, ooh: 0, market: 0, article: 0 });
      state.visible = [];
      return;
    }

    // Counts (full result set, before scope filter)
    var counts = { all: items.length, station: 0, channel: 0, press: 0, ooh: 0, market: 0, article: 0 };
    items.forEach(function (it) { if (counts[it.scope] != null) counts[it.scope]++; });
    syncCounts(counts);

    var filtered = state.scope === 'all' ? items : items.filter(function (it) { return it.scope === state.scope; });
    if (filtered.length === 0) {
      $body.innerHTML = '<div class="mc-sm-no"><h3>No <em>'
        + esc(TYPE_LABEL[state.scope] || state.scope)
        + 's</em> for "' + esc(state.q) + '"</h3>'
        + '<p>Try a different category or clear the filter.</p>'
        + '<div class="mc-sm-no-acts"><button class="mc-sm-no-btn is-sec" data-mc-clearscope>Show all</button></div></div>';
      $body.querySelector('[data-mc-clearscope]').addEventListener('click', function () {
        state.scope = 'all'; syncTabs(); renderResults(items);
      });
      state.visible = [];
      return;
    }

    var ORDER = state.scope === 'all'
      ? ['market', 'station', 'channel', 'press', 'ooh', 'article', 'page']
      : [state.scope];

    var GROUP_LABEL = {
      market: 'Markets', station: 'Stations', channel: 'Channels',
      press: 'Press', ooh: 'Out-of-home', article: 'Articles', page: 'Pages'
    };

    var groups = {};
    ORDER.forEach(function (k) { groups[k] = []; });
    filtered.forEach(function (it) { if (groups[it.scope]) groups[it.scope].push(it); });

    var html = '';
    var idx = 0;
    state.visible = [];
    ORDER.forEach(function (k) {
      var list = groups[k];
      if (!list || !list.length) return;
      html += '<div class="mc-sm-section-h">' + esc(GROUP_LABEL[k]) + ' <span class="num">' + list.length + '</span></div>';
      list.forEach(function (it) {
        state.visible.push(it);
        html += renderRow(it, idx++);
      });
    });
    $body.innerHTML = html;
    state.focus = 0;
    applyFocus();
  }

  function renderRow(item, idx) {
    var iconHtml;
    if (item.scope === 'market' && item.flag) {
      iconHtml = '<span class="mc-sm-ricon is-flag">' + esc(item.flag) + '</span>';
    } else if (item.image) {
      iconHtml = '<span class="mc-sm-ricon"><img src="' + esc(item.image) + '" alt=""></span>';
    } else {
      var glyph = ICONS[item.scope === 'station' ? 'audio'
        : item.scope === 'channel' ? 'video'
        : item.scope === 'press' ? 'press'
        : item.scope === 'ooh' ? 'ooh'
        : item.scope === 'page' ? 'page'
        : 'article'] || ICONS.article;
      iconHtml = '<span class="mc-sm-ricon">' + glyph + '</span>';
    }
    return ''
      + '<a class="mc-sm-result" data-idx="' + idx + '" href="' + esc(item.url || '#') + '" data-result-url="' + esc(item.url || '') + '">'
      +   iconHtml
      +   '<div class="mc-sm-rmain">'
      +     '<div class="mc-sm-rtitle">' + highlight(item.title || '', state.q) + '</div>'
      +     '<div class="mc-sm-rmeta">'
      +       '<span class="mc-sm-pill">' + esc(TYPE_LABEL[item.scope] || item.scope) + '</span>'
      +       (item.meta ? '<span class="mc-sm-dot">·</span><span>' + esc(item.meta) + '</span>' : '')
      +     '</div>'
      +   '</div>'
      +   '<div class="mc-sm-rdetail">' + esc(item.detail || '') + '</div>'
      +   '<svg class="mc-sm-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="13 6 19 12 13 18"/></svg>'
      + '</a>';
  }

  function applyFocus() {
    var rows = $body.querySelectorAll('.mc-sm-result');
    rows.forEach(function (r) { r.classList.remove('is-focus'); });
    var el = $body.querySelector('.mc-sm-result[data-idx="' + state.focus + '"]');
    if (el) {
      el.classList.add('is-focus');
      try { el.scrollIntoView({ block: 'nearest' }); } catch (e) {}
    }
  }

  function syncTabs() {
    $tabs.forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-scope') === state.scope);
    });
  }
  function syncCounts(counts) {
    Object.keys(counts).forEach(function (k) {
      var el = modal.querySelector('[data-count="' + k + '"]');
      if (el) el.textContent = counts[k];
    });
  }

  var runQuery = debounce(function () {
    var q = state.q.trim();
    if (!q) { renderEmpty(); return; }
    fetchResults(q).then(function (items) { renderResults(items); });
  }, 150);

  // ----- Events -----
  $input.addEventListener('input', function (e) {
    state.q = e.target.value;
    runQuery();
  });

  $tabs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.scope = btn.getAttribute('data-scope');
      syncTabs();
      if (state.q.trim()) {
        // Re-render from cache if available
        var items = state.cache[state.q.trim()];
        if (items) renderResults(items); else runQuery();
      }
      $input.focus();
    });
  });

  // Open triggers
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mc-search-open]');
    if (trigger) {
      e.preventDefault();
      openModal();
      return;
    }
    if (e.target.closest('[data-mc-search-close]')) {
      closeModal();
    }
    // Result row → push recent
    var row = e.target.closest('.mc-sm-result');
    if (row && row.dataset.resultUrl) {
      pushRecent(state.q.trim());
    }
  });

  // ⌘K / Ctrl+K
  document.addEventListener('keydown', function (e) {
    var isMeta = (e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K');
    if (isMeta) { e.preventDefault(); openModal(); return; }
    if (modal.getAttribute('aria-hidden') !== 'false') return;

    if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
    if (e.key === 'Tab' && document.activeElement === $input) {
      e.preventDefault();
      var scopes = ['all', 'station', 'channel', 'press', 'ooh', 'market', 'article'];
      var i = scopes.indexOf(state.scope);
      var next = e.shiftKey ? (i - 1 + scopes.length) % scopes.length : (i + 1) % scopes.length;
      state.scope = scopes[next]; syncTabs();
      if (state.q.trim()) {
        var items = state.cache[state.q.trim()];
        if (items) renderResults(items); else runQuery();
      }
      return;
    }
    if (state.visible.length) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        state.focus = (state.focus + 1) % state.visible.length;
        applyFocus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        state.focus = (state.focus - 1 + state.visible.length) % state.visible.length;
        applyFocus();
      } else if (e.key === 'Enter') {
        var sel = state.visible[state.focus];
        if (sel && sel.url) {
          e.preventDefault();
          pushRecent(state.q.trim());
          window.location.href = sel.url;
        }
      }
    } else if (e.key === 'Enter') {
      // Empty results state: fallback to /search?q=X
      var q = state.q.trim();
      if (q) {
        e.preventDefault();
        pushRecent(q);
        window.location.href = SEED.search_url + '?q=' + encodeURIComponent(q);
      }
    }
  });

  // Hover focuses
  $body.addEventListener('mousemove', function (e) {
    var row = e.target.closest('.mc-sm-result');
    if (!row) return;
    var idx = parseInt(row.dataset.idx, 10);
    if (!isNaN(idx) && idx !== state.focus) { state.focus = idx; applyFocus(); }
  });

  // Init
  renderEmpty();
})();
